import * as Sentry from "@sentry/react";
import Alert from "./alert.service";

const handleException = (error: any, { hint, showAlert, alertCallbackFn }: _HandleExceptionProps) => {
  console.error(error);

  try {
    Sentry.captureException(error, { data: hint });
  } catch (ex) {
    console.error(ex);
  }

  // The session interceptor already shows a tailored "session expired" dialog for
  // these — don't overwrite it with the generic message.
  if (showAlert && !error?.sessionExpired) {
    const errorCode = error?.response?.data?.errorCode;
    const isAuthorizationFailure = errorCode === "AUTHORIZATION_FAILURE";

    Alert.simpleAlert({
      header: isAuthorizationFailure ? "Not Authorized" : "Unknown Exception",
      message: isAuthorizationFailure
        ? "You are not authorized to perform this action."
        : `An unknown error occurred, message: ${error}`,
      callbackFn: () => {
        if (alertCallbackFn) alertCallbackFn();
      },
    });
  }
};

interface _HandleExceptionProps {
  hint: any;
  showAlert?: boolean;
  alertCallbackFn?: () => void;
}

const Log = {
  handleException,
};

export default Log;
